module.exports = __webpack_public_path__ + "static/media/joystick.e995ff3c.png";